import { render, staticRenderFns } from "./FantasyTeamSelection.vue?vue&type=template&id=fe9d636a&"
import script from "./FantasyTeamSelection.vue?vue&type=script&lang=js&"
export * from "./FantasyTeamSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports